import { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import MaterialSelect from "../../../../components/MasterSelect";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import {
  deleteLeaveConfigurations,
  employeeTypeOptionapi,
  getLeaveConfiguration,
  leaveConfigurationSubmit,
  leavePeriodOptionapi,
  leaveTypeOptionapi,
  updateLeaveConfiguration,
} from "./api";
import { useLoading } from "../../../../context/loading";

const Addleaveconfiguration = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const { AccessData } = useContext(UserDetailsContext);
  const { setCirleLoading } = useLoading();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [leaveOption, setLeaveOption] = useState([]);
  const [periodOption, setPeriodOption] = useState([]);
  const [employeeOption, setEmployeeOption] = useState([]);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [leaveconfigdata, setleaveconfigdata] = useState({
    leavetype: "",
    leavetypeStatus: "unchecked",
    numberofdays: "",
    numberofdaysStatus: "unchecked",
    periodType: "",
    periodTypeStatus: "unchecked",
    employeeType: "",
    employeeTypeStatus: "unchecked",
  });

  const [originalleaveconfigdata, setoriginalleaveconfigdata] = useState({
    leavetype: "",
    leavetypeStatus: "unchecked",
    numberofdays: "",
    numberofdaysStatus: "unchecked",
    periodType: "",
    periodTypeStatus: "unchecked",
    employeeType: "",
    employeeTypeStatus: "unchecked",
  });

  useEffect(() => {
    employeeTypeOption();
    leaveTypeOption();
    periodTypeOption();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const leaveTypeOption = async () => {
    setCirleLoading(true)
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leaveTypeOptionapi,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setLeaveOption(response?.data?.data?.allLeaveTypes);
    } catch (error) {
      console.log(error);
    } finally{
      setCirleLoading(false)
    }
  };
  const periodTypeOption = async () => {
     setCirleLoading(true)
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leavePeriodOptionapi,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setPeriodOption(response?.data?.data?.allPeriods);
    } catch (error) {
      console.log(error);
    }finally{
       setCirleLoading(false)
    }
  };
  const employeeTypeOption = async () => {
     setCirleLoading(true)
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: employeeTypeOptionapi,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setEmployeeOption(response?.data?.data?.allEmployeeTypes);
    } catch (error) {
      console.log(error);
    } finally{
       setCirleLoading(false)
    }
  };

  const leaveconfigSubmit = async () => {
     setCirleLoading(true)
    const alldata = {
      leaveType: leaveconfigdata.leavetype?.label,
      numberOfDays: leaveconfigdata.numberofdays,
      period: leaveconfigdata?.periodType?.label,
      employeeType: leaveconfigdata?.employeeType?.label,
    };

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leaveConfigurationSubmit,
          variables: { input: alldata },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;

      if (data.errors) {
        throw new Error(data.errors[0]?.message || "Something went wrong");
      }

      if (data.data?.createLeaveConfiguration?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        navigate("/leave-configuration");

        setConfirmationDialog((prev) => ({
          ...prev,
          open: false,
        }));

        setSnackBar((prev) => ({
          ...prev,
          Success: true,
        }));
      }
    } catch (error) {
      console.error("Error submitting leave configuration:", error);

      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    }finally{
       setCirleLoading(false)
    }
  };

  const leaveconfigedit = async () => {
     setCirleLoading(true)
    setPageState({
      ...pageState,
      state: "submitting",
    });

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: updateLeaveConfiguration,
          variables: {
            id,
            input: {
              leaveType: leaveconfigdata.leavetype?.value,
              numberOfDays: leaveconfigdata.numberofdays,
              period: leaveconfigdata?.periodType?.label,
              employeeType: leaveconfigdata?.employeeType?.label,
            },
          },
        }),
      });

      const result = response.data.data?.updateLeaveConfiguration?.success;

      if (result) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/leave-configuration");
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error) {
      console.error("Error:", error);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }finally{
       setCirleLoading(false)
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeletewfh();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeletewfh = async () => {
     setCirleLoading(true)
    try {
      const response = await axios.post(BASEURL, {
        query: deleteLeaveConfigurations,
        variables: {
          id: id,
        },
      });

      const responseData = response.data;

      if (responseData.data.deleteLeaveConfiguration.success) {
        navigate("/leave-configuration");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Leave Configuration Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("An error occurred while deleting the wfh:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }finally{
       setCirleLoading(false)
    }
  };

  const getInitData = async (id) => {
     setCirleLoading(true)
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: getLeaveConfiguration,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveconfigdata = response?.data?.data?.leaveConfigurationById;

      setleaveconfigdata({
        leavetype: {
          value: leaveconfigdata?.leaveType,
          label: leaveconfigdata?.leaveType,
        },
        leavetypeStatus: "success",
        numberofdays: leaveconfigdata?.numberOfDays,
        numberofdaysStatus: "success",
        periodType: {
          value: leaveconfigdata?.period,
          label: leaveconfigdata?.period,
        },
        periodTypeStatus: "success",
        employeeType: {
          value: leaveconfigdata?.employeeType,
          label: leaveconfigdata?.employeeType,
        },
        employeeTypeStatus: "success",
      });

      setoriginalleaveconfigdata({
        leavetype: {
          value: leaveconfigdata?.leaveType,
          label: leaveconfigdata?.leaveType,
        },
        leavetypeStatus: "success",
        numberofdays: leaveconfigdata?.numberOfDays,
        numberofdaysStatus: "success",
        periodType: {
          value: leaveconfigdata?.period,
          label: leaveconfigdata?.period,
        },
        periodTypeStatus: "success",
        employeeType: {
          value: leaveconfigdata?.employeeType,
          label: leaveconfigdata?.employeeType,
        },
        employeeTypeStatus: "success",
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });

      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }finally{
       setCirleLoading(false)
    }
  };

  const handleChange = (event, selectEvent) => {
    let leaveconfig = { ...leaveconfigdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent?.name === "leavetype") {
        if (event?.value) {
          leaveconfig[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveconfig[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent?.name === "periodType") {
        if (event?.value) {
          leaveconfig[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveconfig[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent?.name === "employeeType") {
        if (event?.value) {
          leaveconfig[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveconfig[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      leaveconfig[selectEvent.name] = event;
    } else {
      if (event?.target?.name === "numberofdays") {
        const phoneRegex = new RegExp(/^[0-9]+$/);

        if (phoneRegex.test(event.target.value?.trim())) {
          leaveconfig[event.target.name + "Status"] = "success";
        } else {
          leaveconfig[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
      }
      leaveconfig[event?.target?.name] = event.target.value;
    }
    setleaveconfigdata(leaveconfig);
  };

  const handleAddwfh = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        leaveconfigSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setleaveconfigdata({
      leavetype: originalleaveconfigdata.leavetype,
      numberofdays: originalleaveconfigdata.numberofdays,
      periodType: originalleaveconfigdata?.periodType,
      employeeType: originalleaveconfigdata?.employeeType,
      leavetypeStatus: "success",
      numberofdaysStatus: "success",
      periodTypeStatus: "success",
      employeeTypeStatus: "success",
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      leaveconfigdata.leavetypeStatus === "success" &&
      leaveconfigdata.numberofdaysStatus === "success" &&
      leaveconfigdata?.periodTypeStatus === "success" &&
      leaveconfigdata?.employeeTypeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <>
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Leave Configuration Detail
                      </MaterialTypography>
                    </Stack>
                    {/* {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditLeaveConfiguration" &&
                          item.can_access
                      ) &&
                      pageState.state !== "submitting" && ( */}
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={toggleEdit}
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>

                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={AddDelete}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </MaterialButton>
                    </ButtonGroup>
                    {/* )} */}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Leave Configuration
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent sx={{ height: "300px" }}>
            <MaterialBox>
              <Grid container spacing={2}>
                <Grid size={{ xs: 4, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Leave Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="leavetype"
                    value={leaveconfigdata?.leavetype}
                    onChange={handleChange}
                    error={leaveconfigdata.leavetypeStatus === "error"}
                    success={leaveconfigdata.leavetypeStatus === "success"}
                    isDisabled={togglePage.view === true ? true : false}
                    options={leaveOption?.map((item) => ({
                      value: item?.id,
                      label: item?.leavetype,
                    }))}
                  />
                </Grid>
                <Grid size={{ xs: 4, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Total No Of Days <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="numberofdays"
                    value={leaveconfigdata.numberofdays}
                    onChange={handleChange}
                    error={leaveconfigdata.numberofdaysStatus === "error"}
                    success={leaveconfigdata.numberofdaysStatus === "success"}
                    disabled={togglePage.view === true ? true : false}
                  />
                  {leaveconfigdata.numberofdaysStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Should accept only Numbers maximum of two characters{" "}
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
                <Grid size={{ xs: 4, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Period <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="periodType"
                    value={leaveconfigdata?.periodType}
                    onChange={handleChange}
                    error={leaveconfigdata.periodTypeStatus === "error"}
                    success={leaveconfigdata.periodTypeStatus === "success"}
                    isDisabled={togglePage.view === true ? true : false}
                    options={periodOption?.map((item) => ({
                      value: item?.id,
                      label: item?.period,
                    }))}
                  />
                </Grid>
                <Grid size={{ xs: 4, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Employee Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="employeeType"
                    value={leaveconfigdata?.employeeType}
                    onChange={handleChange}
                    error={leaveconfigdata.employeeTypeStatus === "error"}
                    success={leaveconfigdata.employeeTypeStatus === "success"}
                    isDisabled={togglePage.view === true ? true : false}
                    options={employeeOption?.map((item) => ({
                      value: item?.id,
                      label: item?.employeetype,
                    }))}
                  />
                </Grid>
              </Grid>
            </MaterialBox>
          </CardContent>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  onClick={onDiscardWfh}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={leaveconfigedit}
                >
                  update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddwfh}
              >
                Submit
              </MaterialButton>
            ) : null}
          </MaterialBox>

          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      </>
    </DashboardLayout>
  );
};
export default Addleaveconfiguration;
